import { useEffect } from 'react';
import {
  CONSUMER_CMS_SHOPPING_CART,
  useCmsConfig,
  IPersonalInfoCMS,
  IUserIdentityField,
} from '@vfit/consumer/data-access';
import { API, getClickToCallWithKeyOrUrl, trackLink } from '@vfit/shared/data-access';
import { ConfirmIdentity } from '@vfit/shared/components';
import { ICommonData } from '@vfit/shared/models';
import { organizeConfirmIdentityCard } from './confirmIdentityApp.utils';
import { useCheckout } from '../../../../../iBuyMobile.context';
import TaggingConfirmIdentityApp from './confirmIdentityApp.tagging';
import { useQueryClient } from 'react-query';

const ConfirmIdentityApp = ({ handleOnChangeEnableGoNext }: ICommonData) => {
  const { findCaller, setFindCaller, product } = useCheckout();
  const client = useQueryClient();

  const handleSelect = (selectedItem: IUserIdentityField) => {
    setFindCaller({
      ...findCaller,
      selectedContactMedium: selectedItem.field?.trim() ? selectedItem : undefined,
    });
  };

  const dataFromCms = useCmsConfig(
    CONSUMER_CMS_SHOPPING_CART,
    API.CMS_GET_PERSONAL_DATA
  ) as IPersonalInfoCMS;
  const { descriptionCms, placeholderCms, titleCms, ctaLabelCms, ctaUrl } =
    organizeConfirmIdentityCard(dataFromCms, product);

  const cardConfig = {
    getSelectedData: handleSelect,
    identityTypeItems: [
      findCaller.individualRef.email || '',
      findCaller.individualRef.msisdn || '',
    ],
    title: titleCms,
    description: descriptionCms,
    placeholder: placeholderCms,
    cta: {
      label: ctaLabelCms,
      url: ctaUrl,
      action: () => {
        if (product?.urlClickToCallOtp) {
          trackLink(`verify id:${ctaLabelCms?.toLowerCase()}`);
          getClickToCallWithKeyOrUrl(client, product?.urlClickToCallOtp, product);
        } else if (ctaUrl) {
          trackLink(`verify id:${ctaLabelCms?.toLowerCase()}`);
          window.location.href = ctaUrl;
        } else {
          null;
        }
      },
    },
  };

  useEffect(() => {
    setFindCaller({
      ...findCaller,
      selectedContactMedium: undefined,
    });
  }, []);

  useEffect(() => {
    if (handleOnChangeEnableGoNext) {
      handleOnChangeEnableGoNext(
        !!(findCaller.selectedContactMedium?.field && findCaller.selectedContactMedium.fieldType)
      );
    }
  }, [findCaller.selectedContactMedium]);

  return (
    <>
      <TaggingConfirmIdentityApp />
      <ConfirmIdentity data={cardConfig} />;
    </>
  );
};

export default ConfirmIdentityApp;

